import { ExperienceActivity } from '@types';
import axiosBaseApi from '../axiosBaseApi';

/**
 * Terminate ride session.
 *
 * @param rideId - The ride id to terminate.
 */
export const terminateActiveRideSession = async (rideId: number) => {
	try {
		return await axiosBaseApi.post(`/rides/${rideId}/terminate`);
	} catch (error) {
		console.error('Error fetching bot data:', error);
	}
};

/**
 * Get the experience activity of a ride.
 */
export const getRideExperienceActivity = async (
  id: number,
): Promise<{ experience_activity: ExperienceActivity } | undefined> => {
  try {
    return await axiosBaseApi.get(`/rides/${id}/experience_activity`);
  } catch (error) {
    console.error('Error get ride experience activity:', error);
  }
}
